/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useEffect, useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

import { useHistory, useLocation } from 'react-router-dom'
import { Button, Input } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import FilterListIcon from '@mui/icons-material/FilterList'
import CloseIcon from '@mui/icons-material/Close'
import ExportButton from 'components/ExportButton'
import { buildApplicationSearchParams, getFilterValuesFromQueryParams, setSearchFiltersQueryParams } from 'utils/functions'
import AdvancedFiltersPopover from './AdvancedFiltersPopover'
import styles from './styles'

const SearchBar = (props) => {
  const { searchParams, setSearchParams } = props
  const history = useHistory()
  const location = useLocation()

  const [searchText, setSearchText] = useState(() => getFilterValuesFromQueryParams(location.search).searchTerm)
  const [filterValues, setFilterValues] = useState(() => getFilterValuesFromQueryParams(location.search))
  const isFirstRender = useRef(true)
  const [popoverAnchorEl, setAdvancedFiltersPopoverAnchorEl] = useState(null)
  const [advancedFiltersPopoverOpen, setAdvancedFiltersPopoverOpen] = useState(false)

  const classes = styles()

  const handleSearch = () => {
    const { initDate, endDate, status, result, showEmptyApplications, showWaitingClarification, searchTerm } =
      filterValues

    setSearchParams(buildApplicationSearchParams(filterValues))

    setSearchFiltersQueryParams(history, {
      query: searchTerm !== '' ? searchTerm : undefined,
      start_date: initDate !== '' ? initDate : undefined,
      end_date: endDate !== '' ? endDate : undefined,
      show_apps_without_bgc: showEmptyApplications ? 'true' : undefined,
      status: status !== 'ALL' ? status : undefined,
      result: result !== 'ALL' ? result : undefined,
      waiting_clarification: showWaitingClarification !== 'ALL' ? showWaitingClarification : undefined,
    })
  }
  const changeFilterValue = (newValues = {}) => {
    setFilterValues({ ...filterValues, ...newValues })
  }

  const handleSubmitSearch = () => {
    changeFilterValue({ searchTerm: searchText })
  }

  const handleOnChangeSearchText = (event) => {
    setSearchText(event.target.value)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
    return false
  }

  const handleClickAdvancedFiltering = (event) => {
    setAdvancedFiltersPopoverAnchorEl(event.currentTarget)
    setAdvancedFiltersPopoverOpen(!advancedFiltersPopoverOpen)
  }

  const onClonseAdvancedFiltersPopover = () => {
    setAdvancedFiltersPopoverAnchorEl(null)
    setAdvancedFiltersPopoverOpen(!advancedFiltersPopoverOpen)
  }

  const handleClearFilters = () => {
    setSearchText('')
    setFilterValues(getFilterValuesFromQueryParams(''))
  }

  const hasFiltersApplied = useMemo(() => {
    const { initDate, endDate, status, result, showEmptyApplications, showWaitingClarification, searchTerm } =
      filterValues
    return (
      (searchTerm && searchTerm !== '') ||
      (initDate && initDate !== '') ||
      (endDate && endDate !== '') ||
      (showEmptyApplications && showEmptyApplications !== false) ||
      (status && status !== 'ALL') ||
      (result && result !== 'ALL') ||
      (showWaitingClarification && showWaitingClarification !== 'ALL')
    )
  }, [filterValues])

  useEffect(() => {
    handleSearch()
  }, [filterValues])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (searchText === '') {
      changeFilterValue({ searchTerm: searchText })
    }
  }, [searchText])

  return (
    <React.Fragment>
      <div className={classes.leftSide}>
        <Button className={classes.leftSideButton} onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
        <Input
          className={classes.txtField}
          type="search"
          placeholder="Digite o nome ou CPF do candidato"
          value={searchText}
          onChange={handleOnChangeSearchText}
          onKeyUp={handleEnter}
        />
        <Button
          variant="outlined"
          className={classes.filterButton}
          startIcon={<FilterListIcon />}
          onClick={handleClickAdvancedFiltering}
        >
          Filtros
        </Button>
        { hasFiltersApplied && (
          <Button
          variant="outlined"
          className={classes.filterButton}
          startIcon={<CloseIcon />}
          onClick={handleClearFilters}
        >
          Limpar Filtros
        </Button>
        )}
        <AdvancedFiltersPopover
          anchorEl={popoverAnchorEl}
          open={advancedFiltersPopoverOpen}
          onClose={onClonseAdvancedFiltersPopover}
          filterValues={filterValues}
          changeFilterValue={changeFilterValue}
        />
      </div>
      <div className={classes.rightSide}>
        <ExportButton url="/applications/export" searchParams={searchParams} filename="lista-de-aplicacoes" />
      </div>
    </React.Fragment>
  )
}

SearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default SearchBar
